import { GAME_STATUS } from '@/views/games/Spinners/utils'
import { Model } from '@vuex-orm/core'

const MAX_COMPLETED_GAMES = 12

class SpinnersGame extends Model {
  static entity = 'spinners-game'

  static fields() {
    return {
      id: this.string(null),
      status: this.number(0),
      fairness: this.attr({}),
      slots: this.number(),
      players: this.attr({}),
      data: this.attr({}),
      createdAt: this.attr(),
      expiresAt: this.attr(),
      expiresAtDifferenceMs: this.attr(),
      lockingAt: this.attr(),
      lockingAtDifferenceMs: this.attr(),
      rolledAt: this.attr(),
      rolledAtDifferenceMs: this.attr(),
      outcome: this.number(),
    }
  }

  get amount() {
    return this.players[this.data.creator].amount
  }


  // start to delete completed games after a while
  static afterCreate() {
    const completedGames = SpinnersGame.query()
      .where(game => game.status > GAME_STATUS.locked)
      .orderBy('rolledAt', 'asc')
      .get()

    if (completedGames.length > MAX_COMPLETED_GAMES) {
      completedGames[0].$delete()
    }
  }
}

export default SpinnersGame
